import { startRouter, type Route } from './router/hash-router.ts';
import { matchBlueprint, matchHome, matchDesign, matchPattern, matchPrivacy } from './router/matchers.ts';
import { initLocale, t } from './i18n/index.ts';

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing from index.html');

initLocale();
document.title = t('app.title');
const metaDesc = document.querySelector('meta[name="description"]');
metaDesc?.setAttribute('content', t('app.description'));

const routes: Route[] = [
  { match: matchHome, load: () => import('./pages/gallery.ts') },
  { match: matchDesign, load: () => import('./pages/design.ts') },
  { match: matchBlueprint, load: () => import('./pages/viewer.ts') },
  { match: matchPattern, load: () => import('./pages/viewer.ts') },
  { match: matchPrivacy, load: () => import('./pages/privacy.ts') },
];

startRouter(root, routes, '#/');
